/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("./CreateComponent");
const _ = require("lodash");

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, ExplorerTemplate, Explorables, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._explorerTemplate = new ExplorerTemplate(userSession.activeOrganization.id);
        this._explorablesProm = Explorables.loadExplorables(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }

    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateComponent(this._logger), { dontHide: true })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createTemplate(result.trim()).catch((err) => {
                    this._logger.warn({ error: err }, "CreateAction._createTemplate() error.");
                    if (err.errorCode === "EntityAlreadyExists") {
                        err.errorMsg = `The template named "${result.trim()}" already exists.`;
                    }
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.DEIE_VIEW_DETAILS,
                    viewState: { createMode: true }
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchDataExplorerEditor(editorState, launchOpts);
                if (typeof this._activeView.resetSelection === "function" && typeof this._activeView.loadAndScrollTo === "function") {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }

                return this._reestablishParentFeed();
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn({ error: err }, "CreateAction.run() - Either error or cancellation");
            });
    }

    _createTemplate(name) {
        // Defaults
        return Promise.resolve()
            .then(() => {
                this._explorerTemplate.name = name;
                this._explorerTemplate.description = "";
                this._explorerTemplate.rowOrientedProp = null;
                return this._explorablesProm;
            })
            .then((explorablesEnity) => {
                const field = _.get(explorablesEnity, "explorables.General.Name", undefined);
                if (field) {
                    this._explorerTemplate.setColumns([
                        Object.assign(field, {
                            visible: true
                        })
                    ]);
                }

                return this._explorerTemplate.create();
            });
    }

    _reestablishParentFeed() {
        this._activeView._pagingTemplateFeed.setFilter({});
        return this._activeView._pagingTemplateFeed.reestablish();
    }
}

module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ExplorerTemplate",
    "$teve.entities.Explorables",
    "$teve.userSession",
    "gameEditor.activeView"
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "dataexplorer.add",
    shown: true,
    title: "Create template",
    order: 1
};
